import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Label from "components/Form/Label";
import NextButton from "../NextButton";
import PreviousButton from "../PreviousButton";
import { getAssetsCentral } from "helpers/getExternalURLs";
import get from "lodash/get";
import ConfirmationCode from "../ConfirmationCode";

const ASSETS_CDN = getAssetsCentral();

const Step = ({
  formData,
  nextStep,
  prevStep,
  onUserSignUpByStep,
  onResendCode,
}) => {
  const [verificationCode, setVerificationCode] = useState("");
  const [hasError, setHasError] = useState(false);
  const hasErrorConfirmCode = useSelector(
    (state) => state.signup.hasErrorConfirmCode || null
  );

  useEffect(() => {
    setHasError(hasErrorConfirmCode);
  }, [hasErrorConfirmCode]);

  return (
    <div className="mx-auto w-full lg:w-[480px]">
      <div>
        <h1 className="my-4 text-2xl md:text-3xl font-bold tracking-tight text-primary-700">
          {`Just a minute, ${get(formData, "first_name", "")} ✋`}
        </h1>
        <p className="mt-2 text-sm text-primary-700">
          We’re happy you’ve started the process. Please check your email and
          enter the verification code below.
        </p>
      </div>
      <div className="mt-8">
        <form action="#" method="POST" className="mb-4">
          <Label>Verification code</Label>
          <ConfirmationCode
            hasError={hasError ? hasErrorConfirmCode : null}
            onChange={(value) => {
              setHasError(false);
              setVerificationCode(String(Array.from(value.values()).join("")));
            }}
          />
          <div className="w-full text-right mb-4">
            <button
              type="button"
              className="underline text-brand-500 text-sm font-semibold appearance-none"
              onClick={onResendCode}
            >
              Resend code
            </button>
          </div>
          <div className="w-full">
            <img
              src={`${ASSETS_CDN}/images/signup-hold-on.gif`}
              alt="Code verification"
              className="max-w-full h-auto rounded-lg"
            />
          </div>
        </form>
        <div></div>
        <div className="w-full flex justify-between">
          <PreviousButton onClick={prevStep} />
          <NextButton
            onClick={() => {
              onUserSignUpByStep(verificationCode, () => {
                nextStep();
              });
            }}
            disabled={!verificationCode || verificationCode.length < 6}
          />
        </div>
      </div>
    </div>
  );
};

export default Step;
